module.exports = __webpack_public_path__ + "sharp-sans-bold-subset-19c0ab0e965ceab98e3dbeae2f97b950.bundle.woff2";